// DS: i4.15
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Cake: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M9.75 6.004L10 6a.991.991 0 011 1v6h6a1 1 0 01.993.883L18 14a8 8 0 11-8.25-7.996zm4.059-3.968l.27.028a9.004 9.004 0 017.86 7.88l.03.3v.032c0 .367-.272.67-.626.717l-.098.007H14a1 1 0 01-.993-.883L13 10V2.743l.003-.033a.743.743 0 01.806-.674z"
      />
    </svg>
  </IconWrap>
);
Cake.displayName = 'Cake';

export default Cake;
